import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../creds';
// import SpeakButton from './SpeakButton';

const slugify = (title) => {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
};

const openNews = (title) => slugify(title);

const TopSectionNewsCard = ({ id, title, content, photo_url, date }) => {
  return (
    <Link
      to={`/news/${id}-${openNews(title)}`}
      className="border border-gray-200 rounded-lg overflow-hidden shadow-sm flex flex-col md:flex-row"
    >
      {photo_url ? (
        <img
          src={`${API_BASE_URL}/images/${photo_url}`}
          alt={title}
          className="w-full md:w-1/3 h-[300px]"
        />
      ) : (
        <div
          className="w-full md:w-1/3 h-[300px] bg-gray-200 flex items-center justify-center"
        >
          <span className="text-gray-500">No Image</span>
        </div>
      )}
      <div className="p-4 md:w-2/3 flex flex-col">
        <h3
          className="font-semibold text-gray-800 hover:text-blue-500 text-2xl"
        >
          {title || 'Untitled'}
        </h3>
        <p className="text-gray-600 mt-2 line-clamp-3 flex-1 text-xl text-justify">
          {content || 'No content available'}
        </p>
        <div className="flex flex-wrap justify-between mt-2">
          <div className="text-sm text-gray-500">
            <span>
              {date
                ? new Date(date).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                  })
                : 'Unknown date'}
            </span>
          </div>
          {/* <div>
            <SpeakButton text={`${title}\n${content}`.toString()} />
          </div> */}
        </div>
      </div>
    </Link>
  );
};

TopSectionNewsCard.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  photo_url: PropTypes.string,
  source: PropTypes.string,
  date: PropTypes.string,
  isFeatured: PropTypes.bool,
};

export default TopSectionNewsCard;